"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResource = exports.createNote = exports.EnexDumperOptions = exports.EnexDumper = void 0;
// import { EnexDumper } from './EnexDumper';
var EnexDumper_1 = require("./EnexDumper");
Object.defineProperty(exports, "EnexDumper", { enumerable: true, get: function () { return EnexDumper_1.EnexDumper; } });
// import { EnexDumperOptions } from './EnexDumperOptions';
var EnexDumperOptions_1 = require("./EnexDumperOptions");
Object.defineProperty(exports, "EnexDumperOptions", { enumerable: true, get: function () { return EnexDumperOptions_1.EnexDumperOptions; } });
var NoteSource_1 = require("./NoteSource");
Object.defineProperty(exports, "createNote", { enumerable: true, get: function () { return NoteSource_1.createNote; } });
Object.defineProperty(exports, "createResource", { enumerable: true, get: function () { return NoteSource_1.createResource; } });
// import { recursiveHTMLDumper, WritableFile } from './FileSystemSource';
// export { recursiveHTMLDumper, WritableFile } from './FileSystemSource';
// const outputDirname = process.argv[process.argv.length - 2];
// const outputFilename = process.argv[process.argv.length - 1];
// const options = new EnexDumperOptions();
// const writer = new WritableFile(outputFilename);
// const dumper = new EnexDumper(writer, options);
// recursiveHTMLDumper(outputDirname, dumper);
// async () => {
//     await dumper.done;
//     await writer.result;
// }
